import React from 'react';
import { Link } from 'react-router-dom';
import { networkPath, walletPath } from '../utils/chains';

/**
 * A wallet or network address link to our own pages, chain-scoped for EVM
 * (/wallet/<chain>/<0x…>; EVM networks open the root wallet's page).
 */
const AddressLink: React.FC<{
  address: string | null | undefined;
  chain?: string | null;
  kind?: 'wallet' | 'network';
  className?: string;
  onClick?: React.MouseEventHandler;
  children: React.ReactNode;
}> = ({ address, chain, kind = 'wallet', className, onClick, children }) => {
  const to = kind === 'network' ? networkPath(address ?? '', chain) : walletPath(address ?? '', chain);
  return <Link to={to} className={className} onClick={onClick}>{children}</Link>;
};

export default AddressLink;
